import { DocumentTitle } from "src/base-components/DocumentTitle";
import { UnifiedCopilotChat } from "src/unifiedCopilot/chat/UnifiedCopilotChat";
import { UnifiedCopilotHeader } from "src/unifiedCopilot/UnifiedCopilotHeader";

export const UnifiedCopilotPage: React.FC = () => (
  <div
    className="flex h-full min-h-0 flex-col bg-white"
    data-loc="unified-copilot-page"
  >
    <DocumentTitle segments={["Taktile Agent"]} />
    <UnifiedCopilotHeader surface="page" />
    <main className="min-h-0 flex-1">
      <UnifiedCopilotChat variant="page" />
    </main>
  </div>
);
